// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./shark-ninja/cartridges/app_custom_sharkninja_core/cartridge/client/default/js/experience/components/popularCategoryTile.js");
